"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = ["innerHTML"];
var _hoisted_2 = ["innerHTML"];
var vue_3 = require("vue");
var InfoBox_vue_1 = require("./InfoBox.vue");
var announcements_query_1 = require("@/queries/announcements.query");
exports.default = (0, vue_1.defineComponent)({
    __name: 'BaseAnnouncement',
    setup: function (__props) {
        var _this = this;
        (0, vue_3.onBeforeMount)(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!announcements_query_1.data.value) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, announcements_query_1.getAnnouncements)()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        return function (_ctx, _cache) {
            var _a, _b, _c, _d;
            return ((_d = (_c = (_b = (_a = (0, vue_2.unref)(announcements_query_1.data)) === null || _a === void 0 ? void 0 : _a.publication) === null || _b === void 0 ? void 0 : _b.announcement) === null || _c === void 0 ? void 0 : _c.schema_elements) === null || _d === void 0 ? void 0 : _d.length)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(InfoBox_vue_1.default, {
                    key: 0,
                    class: "mb-6"
                }, {
                    default: (0, vue_2.withCtx)(function () { return [
                        ((0, vue_2.unref)(announcements_query_1.data).publication.announcement.name)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: 0,
                                class: "mb-2 font-medium",
                                innerHTML: (0, vue_2.unref)(announcements_query_1.data).publication.announcement.name
                            }, null, 8, _hoisted_1))
                            : (0, vue_2.createCommentVNode)("", true),
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(announcements_query_1.data).publication.announcement.schema_elements, function (content, i) {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: i,
                                innerHTML: content.content
                            }, null, 8, _hoisted_2));
                        }), 128))
                    ]; }),
                    _: 1
                }))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
